export default __webpack_public_path__ + "static/media/1803.7566f3ab.png";